import { useRouteError } from 'react-router'
import { ErrorBoundary } from '#/components/error-boundary'


export default function NoOrganizationError() {
  const error = useRouteError()

  return (
    <div>
      <ErrorBoundary error={error} />
    </div>
  )
}
